import { useEffect } from "react";
import { createFileRoute } from "@tanstack/react-router";
import Loading from "../components/core/blocks/Loading";
import { LoginForm } from "../modules/auth/LoginForm";
import { forwardSignedInUser } from "../modules/auth/routeGuards";

function LoginPage() {
  const source = Route.useSearch({ select: (search) => search.source });

  useEffect(() => {
    if (source === "extension" && !localStorage.extensionSignup) {
      localStorage.extensionSignup = new Date().toISOString().split("T")[0];
    }
  }, [source]);

  return <LoginForm />;
}

export const Route = createFileRoute("/")({
  beforeLoad: forwardSignedInUser,
  pendingComponent: () => <Loading height="100vh" />,
  component: LoginPage,
});
